module.exports = __webpack_public_path__ + "img/idNumberImg.be7a72ff.png";